import { useEffect } from 'react';
import FormContainer from '../common/FormContainer';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { useRedirectUrl } from '../../lib/hooks/useRedirect';

const SignInSuccess = () => {
  const { t } = useTranslation();
  const redirectUrl = useRedirectUrl();

  useEffect(() => {
    setTimeout(() => window.location.replace(redirectUrl));
  }, []);

  return (
    <FormContainer>
      <Paper square sx={{ p: 3, width: 425 }}>
        <Typography variant="h5" gutterBottom>
          {t('auth.redirecting')}
        </Typography>
      </Paper>
    </FormContainer>
  );
};


export default SignInSuccess;
